/** Branded intro splash on cold load (dev + prod web). */
export function isWebSplashEnabled(): boolean {
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
  return projectId === 'huakya-dev' || projectId === 'huakya-7b87e';
}

export const WEB_SPLASH_MS = 4000;

export function getWebSplashMs(): number {
  return WEB_SPLASH_MS;
}
